<template>
	<div class="animated fadeIn">


		<div class="row">
			<div class="col-xs-12">
				<h2>
					<i class="fa fa-fire text-success"></i>
					<span v-show="!person.editMode">创建教学团队</span>
					<span v-show="person.editMode">编辑教学团队</span>
				</h2>
				<div class="pull-right">
					<CreateSaveButton :entity="person" :callback="save"/>
				</div>
			</div>
		</div>


		<div class="row">


			<div class="col-xs-12 m-t-md">


				<div class="form-group">
					<label class="control-label compulsory">名字</label>
					<input type="text" class="form-control" v-model="person.name">
				</div>

				<div class="form-group" v-show="false">
					<label class="control-label"><span class="text-danger">*</span>类别</label>
					<select class="form-control m-b" name="type" v-model="person.type">
						<option v-for="type in person.TypeList" :value="type.value">{{type.name}}</option>
					</select>
				</div>


				<div class="form-group clear">
					<img class="thumb-lg pull-left m-r-md">
					<label class="control-label compulsory">图片(建议尺寸400*400)</label>

					<div>
						<NbTank :tank="person.image"/>
					</div>

				</div>

				<div class="form-group">
					<label class="control-label compulsory">头衔</label>
					<input type="text" class="form-control" v-model="person.title">
				</div>

				<div class="form-group">
					<label class="control-label">电话</label>
					<input type="text" class="form-control" v-model="person.phone">
				</div>

				<div class="form-group">
					<label class="control-label">电子邮件</label>
					<input type="text" class="form-control" v-model="person.email">
				</div>


				<div class="form-group" v-show="false">
					<label class="control-label">办公地点</label>
					<input type="text" class="form-control" v-model="person.office">
				</div>

				<div class="form-group">
					<label class="control-label compulsory">简介</label>
					<div>
						<NbEditor v-model="person.description"/>
					</div>
				</div>


			</div>
			<div class="col-xs-12 m-t-md">
				<div class="alert alert-danger" v-show="person.errorMessage">
					{{person.errorMessage}}
				</div>
				<div class="pull-right">
					<CreateSaveButton :entity="person" :callback="save"/>
				</div>
			</div>
		</div>

	</div>

</template>
<script>
	import NbTank from '../../../common/widget/NbTank'
	import {simpleDateTime, str2Date} from '../../../common/filter/time'
	import {Notification} from 'element-ui';
	import Person from '../../../common/model/person/Person'
	import NbEditor from "../../../common/widget/NbEditor"
	import CreateSaveButton from "../widget/CreateSaveButton.vue"

	export default {

		data () {
			return {
				person: new Person()
			}
		},
		components: {
			NbTank,
			NbEditor,
			CreateSaveButton
		},
		computed: {},
		watch: {},
		methods: {
			save(){
				let that = this;
				this.person.httpSave(function (response) {

					Notification.success({
						message: that.person.editMode ? '修改教学团队成功！' : '创建教学团队成功！'
					});
					that.$router.push("/cgd/by/person/list");

				});
			}
		},


		mounted(){

			let that = this;

			this.person.id = this.$store.state.route.params.id;
			that.person.image.privacy = false;

			if (this.person.id) {

				this.person.editMode = true;
				this.person.httpDetail();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Create.vue?db7fffd0